const schoolFines = (() => {

    const calc = document.getElementById('cnfsd-school-fines');
    const form = document.getElementById('sf-screen-one');
    const results = document.getElementById('sf-screen-two');
    const resetBtn = document.getElementById('sf-reset');

    let country = "";
    let county = "";
    let counties = [];
    let councils = [];
    let jsonData;

    const childrenInput = document.getElementById('sfChildren');
    const countrySelect = document.getElementById('country-select');
    const countySelect = document.getElementById('county-select');
    const councilSelect = document.getElementById('council-select');

    const countryQuestion = document.querySelector('.country-question');
    const countyQuestion = document.querySelector('.county-question');
    const councilQuestion = document.querySelector('.council-question');

    const progressBar = document.querySelector(".banner__progress-bar > span");
    const progressTitle = document.querySelector(".banner__title");
    const progressNumber = document.querySelector(".banner__progress-step-value");

    // Results selectors
    let resultsElem = null;
    let screenHeading = null;
    const tooltipWales = document.querySelector('.council-tooltip--wales');
    const tooltipEngland = document.querySelector('.council-tooltip--england');

    const finesData = {
        wales: 120,
        england: 160,
        northernireland: 1000
    }

	const setupListeners = () => {
        childrenInput.addEventListener('keydown', e => removeError(e));
        [childrenInput, countrySelect, countySelect, councilSelect].forEach(elem => elem.addEventListener('change', e => removeError(e)));
        countrySelect.addEventListener('change', e => handleCountryChange(e));
        countySelect.addEventListener('change', e => {
            populateCouncilOptions(e, "england", "")
            handleCouncilChange(null, councilSelect.value, countrySelect.value);
        });
        councilSelect.addEventListener('change', e => handleCouncilChange(e, "", ""));
        resetBtn.addEventListener('click', handleReset);
    };

    const handleCountryChange = e => {

        country = e.target.value.toLowerCase();

        countySelect.value = "";
        councilSelect.value = "";

        if (country === "england") {
            countyQuestion.classList.remove('display-none');
            councilQuestion.classList.remove('display-none');
            populateCountyOptions();
            populateCouncilOptions(null, "england", countySelect.value);
            handleCouncilChange(null, councilSelect.value, countrySelect.value);
        } else if (country === "northernireland") {
            countyQuestion.classList.add('display-none');
            councilQuestion.classList.add('display-none');
        } else if (country === "scotland") {
            countyQuestion.classList.add('display-none');
            councilQuestion.classList.add('display-none');
        } else if (country === "wales") {
            countyQuestion.classList.add('display-none');
            councilQuestion.classList.remove('display-none');
            populateCouncilOptions(null, 'wales', "");
            handleCouncilChange(null, councilSelect.value, countrySelect.value);
        }
        removeAllSelectErrors();
    }

    const handleCouncilChange = (e, councilArg = "", countryArg = "") => {
        const councilSelected = councilArg === "" ? e.target.value : councilArg;

        if (countryArg === "england") {
            resultsElem = document.querySelector(".sf-results--eng");
        } else if (countryArg === "wales") {
            resultsElem = document.querySelector(".sf-results--wales");
        }

        const localAuthoritySpan = resultsElem.querySelector(".dynamic--local-authority");
        const finesIssuedSpan = resultsElem.querySelector(".dynamic--fines-issued");
        
        let finesIssued;
        if (country === "england") {
            finesIssued = jsonData.countries
                .find(c => c.name === country)
                ?.counties
                .find(cnty => cnty.name === county)
                ?.councils
                .find(ccil => ccil.name === councilSelected)
                .totalFinesIssued;
        } else if (country === "wales") {
            finesIssued = jsonData.countries
                .find(c => c.name === country)
                ?.councils
                .find(ccil => ccil.name === councilSelected)
                ?.totalFinesIssued;
        }
        if (finesIssuedSpan) finesIssuedSpan.textContent = `${finesIssued}**`;

        if (country === "wales") {
            if (localAuthoritySpan) localAuthoritySpan.textContent = councilSelected;
        } else {
            if (localAuthoritySpan) localAuthoritySpan.textContent = county === "" ? `${country.charAt(0).toUpperCase() + country.slice(1)}` : councilSelected;
        }
    }

    const populateCountyOptions = () => {
        counties = jsonData.countries.find(c => c.name === country).counties;
        if (!counties || counties.length === 0) return;
        counties.forEach((county, index) => {
            const option = document.createElement('option');
            option.value = county.name;
            option.textContent = county.name;
            if (index === 0) option.selected = true;
            countySelect.appendChild(option);
        });
    }

    const populateCouncilOptions = (e, selectedCountry, countyArg = "") => {

        councilSelect.length = 0;

        if (selectedCountry === "wales") {
            councils = jsonData.countries.find(c => c.name === country).councils;
        } else {
            county = countyArg === "" ? e.target.value : countyArg;
            councils = jsonData.countries
                .find(c => c.name === country)
                ?.counties
                .find(cnty => cnty.name === county)
                ?.councils;
            if (councils.length > 0) councilQuestion.classList.remove('display-none');
        }

        if (!councils || councils.length === 0) return;
            councils.forEach((council, index) => {
                const option = document.createElement('option');
                option.value = council.name;
                option.textContent = council.name;
                if (index === 0) option.selected = true;
                councilSelect.appendChild(option);
        });
    }

    const formValidation = (elem, type) => {
        let isValid = true;
        const fieldset = elem.closest('.field-group');
        let errorMessage = '';
    
        switch (type) {
            case 'isSelected':
                if (elem.value === '' || elem.value === null) {
                    isValid = false;
                    errorMessage = elem.dataset.errorEmpty;
                }
                break;
            case 'numberIsEmpty':
                if (elem.value === '' || elem.value === null || elem.value <= 0) {
                    isValid = false;
                    errorMessage = 'Enter the number of children absent';
                }
                break;
            default:
                alert('Unknown validation type');
        }
    
        const errorEl = fieldset.querySelector('.error-message');
        if (isValid) {
            fieldset.classList.remove('field-group--error');
        } else {
            if (errorMessage && errorEl) {
                errorEl.textContent = errorMessage;
            }
            fieldset.classList.add('field-group--error');
        }
    
        return isValid;
    };

    const removeError = e => {
        const fieldGroup = e.target.closest('fieldset');
        if (fieldGroup && fieldGroup.classList.contains('field-group--error')) fieldGroup.classList.remove('field-group--error');
    }

    const removeAllSelectErrors = () => {
        [countryQuestion, countyQuestion, councilQuestion].forEach(elem => elem.classList.remove('field-group--error'));
    }

    const handleFormSubmit = e => {
        e.preventDefault();

        const childrenValid = formValidation(childrenInput, 'numberIsEmpty');
        const countryValid = formValidation(countrySelect, 'isSelected');

        if (!childrenValid || !countryValid) return;
        
        handleProgressTracker('forward');
        populateResults();
        calc.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    const handleProgressTracker = direction => {
        if (direction == "forward") {
            progressBar.classList.remove('progress-1');
            progressBar.classList.add('progress-2');
            progressNumber.textContent = "2";
            progressTitle.textContent = "Results";
        } else {
            progressBar.classList.add('progress-1');
            progressBar.classList.remove('progress-2');
            progressNumber.textContent = "1";
            progressTitle.textContent = "Details";
        }
    }

    const populateResults = () => {

        if (country === "scotland") {
            resultsElem = document.querySelector(".sf-results--scotland");
        } else if (country === "england") {
            resultsElem = document.querySelector(".sf-results--eng");
            screenHeading = document.querySelector(".sf-screen-heading--england");
            tooltipEngland.classList.remove('display-none');
        } else if (country === "wales") {
            resultsElem = document.querySelector(".sf-results--wales");
            screenHeading = document.querySelector(".sf-screen-heading--wales");
            tooltipWales.classList.remove('display-none');
        } else if (country === "northernireland") {
            resultsElem = document.querySelector(".sf-results--ni");
        } else {
            return;
        }

        const noOfChildrenSpan = resultsElem.querySelector(".dynamic--children");
        const amountSpan = resultsElem.querySelector(".dynamic--amount");

        const totalChildren = Number(childrenInput.value);
        const string = totalChildren === 1 ? "1 child" : `${totalChildren} children `;

        if (noOfChildrenSpan) noOfChildrenSpan.textContent = string;
        if (amountSpan) amountSpan.textContent = `${finesData[country] * Number(childrenInput.value)}`;

        if (screenHeading !== null) screenHeading.classList.remove("display-none");
        
        form.classList.add('display-none');
        results.classList.remove('display-none');
        resultsElem.classList.remove("display-none");        
    }

    const handleReset = () => {
        handleProgressTracker('back');
    
        country = "";
        county = "";
        counties = [];
        councils = [];
    
        screenHeading?.classList.add("display-none");
        screenHeading = null;
        resultsElem?.classList.add("display-none");
        countyQuestion?.classList.add("display-none");
        councilQuestion?.classList.add("display-none");
        form?.classList.remove("display-none");
        results?.classList.add("display-none");
        tooltipWales?.classList.add("display-none");
        tooltipEngland?.classList.add("display-none");
    
        if (childrenInput) childrenInput.value = "";
        [countySelect, councilSelect].forEach(elem => {
            if (elem) elem.length = 0;
        });
        countrySelect.value = "";
        calc?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    

    const init = async () => {
        setupListeners();
        form.addEventListener('submit', handleFormSubmit);
        const data = await fetch(document.getElementById('sf-json').getAttribute('data-json-path'));
        jsonData = await data.json();
	};

	return {
		init: init,
	};
})();

document.addEventListener('DOMContentLoaded', () => {
	schoolFines.init();
});